import { mapActions } from 'vuex';

import bus from '@/utils/bus';

export default {
  name: 'ContinueShareLink',
  props: {
    value: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    ...mapActions({
      resetState: 'reset',
    }),
    close() {
      this.$emit('input', false);
    },
    logoutAndContinue() {
      localStorage.clear();
      this.resetState();
      bus.$emit('CLEAR_TEMP_COMPANY_NAME');
      this.close();
      window.location.reload();
    },
    onCancel() {
      this.$router.replace('/menu');
      this.close();
    },
  },
};
